import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Location as AngularLocation} from '@angular/common';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';
import { Observable } from 'rxjs/Observable';
import { TdLoadingService, TdDialogService, ITdDataTableColumn } from '@covalent/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { Location} from '../../location';
import { Pallet } from '../pallet';
import { PalletService } from '../../../../shared/services/pallet.service';
import { Branch } from '../../branch';
import { LocationService } from 'services/location.service';
import { InventoryService } from 'app/agatextscreens/inventory/inventory.service';
import { Piece } from 'app/agatextscreens/inventory/piece';

@Component({
  selector: 'app-pallet',
  templateUrl: './pallet.component.html',
  styleUrls: ['./pallet.component.scss'],
  providers: [PalletService]
})
export class PalletComponent implements OnInit {
  _loading: number = 0;

  allBranches$: Observable<Branch[]>;
  availableLocations: Location[] = [];

  branchFilter;
  locationFilter;

  finalLocation: Location;

  translatePipe: TranslatePipe = new TranslatePipe();
  currentPallet: Pallet = new Pallet();
  originalPallet: Pallet = new Pallet();

  isEditMode: boolean;

  itemsInPallet: Piece[] = [];

  columns: ITdDataTableColumn[] = [
    { name: 'piece_number', label: 'Piece no.' },
    { name: 'collection_name', label: 'Collection' },
    { name: 'design_name', label: 'Design' },
    { name: 'color_name', label: 'Color' },
  ];

  constructor(
    public _authService: AuthenticationService,
    private _loadingService: TdLoadingService,
    private _palletService: PalletService,
    private _location: AngularLocation,
    private _inventoryService: InventoryService,
    private _locationService: LocationService,
    private route: ActivatedRoute,
    private router: Router,
    private _dialog: TdDialogService
  ) { }

  ngOnInit() {
    //this._loadingService.register('loading');
    this._loading ++;

    this.allBranches$ = Observable.of(this._authService.getUserBranches());

    this.route.paramMap.switchMap((params: ParamMap) => this.mode(params.get('id'))).subscribe(
      (currentPallet: Pallet) => {

        this._loading --;

        this.currentPallet = currentPallet;

        // If it is not new
        if (currentPallet.location_branch_id) {
          // Make the branch appear
          this.branchFilter = currentPallet.location_branch_id;

          // Then get all the selected branch's locations
          this.getLocationsForBranch(currentPallet.location_branch_id);

          // And get the pieces in this pallet
          this._loading ++;
          this._inventoryService.findByPallet(currentPallet.name, currentPallet.location_branch_id).subscribe(
            response => {
              this._loading --;
              this.itemsInPallet = response;
              console.log(this.itemsInPallet);
              this.filter();
            },
            error => {
              console.log (error);
              this._loading --;
            }
          );

          this.originalPallet = this.currentPallet;
        }

      });

  }

  getLocationsForBranch($event) {
    this._loading ++;
    this._locationService.getLocations($event).subscribe(
      response => {
        this._loading --;
        console.log(response);
        this.availableLocations = response;
      },
      error => {
        this._loading --;
        console.log(error);
      });
  }

  changed(): boolean {
    for (let prop in this.currentPallet) {
      if (this.currentPallet[prop] != this.originalPallet[prop]) {
        return true;
      }
    }

    return false;
  }


  mode(id: string): Observable<Pallet> {
    if (id) {
      this.isEditMode = true;
      return this._palletService.getPallet(id);
    } else {
      this.isEditMode = false;
      return Observable.of(new Pallet());
    }
  }


  // Create a new pallet
  create() {
    console.log(this.currentPallet);

    if (!this.checkMandatoryFields()) {
      return;
    }

    if (!this.setLocation()) {
      return;
    }

    this._palletService.createPallet(this.currentPallet).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {

          this._dialog.openAlert({
            title: this.translatePipe.transform('success', this._authService.getLanguage()),
            message: this.translatePipe.transform('pallet_created_successfully', this._authService.getLanguage())
          });
          this.router.navigate(['/accounting', 'pallets']);

        } else {
          this._dialog.openAlert({
            title: this.translatePipe.transform('error', this._authService.getLanguage()),
            message: this.translatePipe.transform('could_not_create', this._authService.getLanguage()) + ': ' + response['error']
          });
        }
      },
      error => {
        this._dialog.openAlert({
          title: this.translatePipe.transform('error', this._authService.getLanguage()),
          message: this.translatePipe.transform('could_not_create', this._authService.getLanguage()) + ': ' + error
        });
      }
    );
  }

  // Update an existing pallet
  save() {
    if (!this.checkMandatoryFields()) {
      return;
    }

    if (!this.setLocation()) {
      return;
    }

    this._palletService.updatePallet(this.currentPallet.id, this.currentPallet).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {

          this._dialog.openAlert({
            title: this.translatePipe.transform('success', this._authService.getLanguage()),
            message: this.translatePipe.transform('pallet_updated_successfully', this._authService.getLanguage())
          });
          this.router.navigate(['/accounting', 'pallets']);

        } else {
          this._dialog.openAlert({
            title: this.translatePipe.transform('error', this._authService.getLanguage()),
            message: this.translatePipe.transform('could_not_update', this._authService.getLanguage()) + ': ' + response['error']
          });
        }
      },
      error => {
        this._dialog.openAlert({
          title: this.translatePipe.transform('error', this._authService.getLanguage()),
          message: this.translatePipe.transform('could_not_update', this._authService.getLanguage()) + ': ' + error
        });
      }
    );

  }

  checkMandatoryFields(): boolean {
    let message: string[] = [];

    if (!this.availableLocations || this.availableLocations.length < 1) {
      message.push(this.translatePipe.transform('branch_is_mandatory', this._authService.getLanguage()));
    }

    if (this.currentPallet.name == null) {
      message.push(this.translatePipe.transform('name_is_mandatory', this._authService.getLanguage()));
    }

    if (!this.currentPallet.location_name) {
      message.push(this.translatePipe.transform('location_is_mandatory', this._authService.getLanguage()));
    }

    if (message.length > 0) {
      this._dialog.openAlert({ title: this.translatePipe.transform('invalid_input', this._authService.getLanguage()), message: message.join('. ') });
      return false;
    }

    return true;
  }


  setLocation(): boolean {
    // if the entered location isn't in the array of all location for the selected branch then error
    let selectedLocation: Location = this.availableLocations.find(i => i.name === this.currentPallet.location_name);
    console.log('selected location', selectedLocation);


    if (!selectedLocation) {
      this._dialog.openAlert({ title: this.translatePipe.transform('invalid_input', this._authService.getLanguage()), 
      message: this.translatePipe.transform('invalid_location', this._authService.getLanguage()) });
      return false;
    }

    this.currentPallet.location_id = selectedLocation.id;
    return true;
  }


  goBack() {
    this._location.back();
  }

  filter() {

  }
}





// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/pallets/pallet/pallet.component.ts